import { gql } from '@apollo/client'
import { Notification } from 'share/domain/notification'

// NotificationList start

export const GET_NOTIFICATIONS_BY_CASE = gql`
  query GET_NOTIFICATIONS_BY_CASE($caseId: Int!) {
    notifications {
      get(where: { caseId: $caseId }) {
        id
        type
        description
        notificationTime
        caseId
        read
        readTime
        delivered
        notificationDisplayType
        notificationType
        case {
          caseNumber
          caseType
        }
      }
    }
  }
`

export const GET_ALL_UNREAD_NOTIFICATIONS = gql`
  query GET_ALL_UNREAD_NOTIFICATIONS($read: Boolean!) {
    notifications {
      get(where: { read: $read }) {
        id
        type
        description
        notificationTime
        caseId
        read
        readTime
        delivered
        notificationDisplayType
        notificationType
        case {
          caseNumber
          caseType
        }
      }
    }
  }
`
export const COUNT_UNREAD_NOTIFICATIONS = gql`
  query GET_ALL_UNREAD_NOTIFICATIONS {
    notifications {
      get(where: { read: false }) {
        id
      }
    }
  }
`

export const GET_ALL_NOTIFICATIONS = gql`
  query GET_ALL_NOTIFICATIONS {
    notifications {
      get {
        id
        type
        description
        notificationTime
        read
        readTime
        caseId
        delivered
        notificationDisplayType
        notificationType
        case {
          caseNumber
          caseType
        }
      }
    }
  }
`

export interface GetNotificationsByCaseVariables {
  caseId: number
  read?: boolean
}

export interface GetAllUnreadNotificationsVariables {
  read: boolean
}

export interface NotificationListResponse {
  notifications: {
    get: Notification[]
  }
}

export interface NotificationCountResponse {
  notifications: {
    get: [
      {
        id: number
      }
    ]
  }
}
